import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddIcon, SearchesCIcon } from "../Assets/iconshere";
import axios from "axios";
import { useSelector } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import EventsListCards from "./EventsListCards";
import apiClient from "../apiClient";

const Events = ({ setSideBar }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  var navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [search, setSearch] = useState("");
  const [ongoingList, setOngoingList] = useState([]);
  const [expiredList, setExpiredList] = useState([]);
  const [ongoingLoading, setOngoingLoading] = useState(true);
  const [expireLoading, setExpireLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("ongoing");

  const getEvent = async (tab) => {
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/event/list/${tab}`);

      // let { data } = await axios.get(`${configData.config.API_URL}/api/event/list/${tab}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      if (tab === "ongoing") {
        setOngoingList(data);

        setOngoingLoading(false);
      } else if (tab === "expired") {
        setExpiredList(data);

        setExpireLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteEvent = async (id) => {
    try {


      await apiClient.delete(`${configData.config.API_URL}/api/event/delete/${id}`);

      setShowDelete(false);
    } catch (error) {
      console.log(error);
    } finally {
      getEvent(currentTab);
    }
  };

  useEffect(() => {
    getEvent(currentTab);
  }, [currentTab]);

  useEffect(() => {
    const intervalId = setInterval(() => getEvent(currentTab), 60000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <Tab.Container id="my-tabs" activeKey={currentTab} onSelect={(key) => setCurrentTab(key)}>
        <Nav className="tabsproduct updated toptab" variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="ongoing">Ongoing Events</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="expired">Past Events</Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="container-fluid bg-grey-main dashboard p-3 pt-5">
          <div className="uppersection pt-3">
            <form className=" app-search app-search1">
              <div className="position-relative">
                <SearchesCIcon />
                <input
                  type="text"
                  name="searchName"
                  className="form-control"
                  placeholder="Search"
                  autoComplete="off"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </form>
            <div className="d-flex align-items-center justify-content-end gap-2">
              {ongoingList.length > 0 && (
                <button className="DefaultRedBtn" onClick={() => navigate(`/events/create`)}>
                  <AddIcon /> Create Event
                </button>
              )}
            </div>
          </div>

          <Tab.Content className="pt-3">
            <Tab.Pane eventKey="ongoing">
              <div className="row">
                <EventsListCards
                  setSideBar={setSideBar}
                  list={ongoingList}
                  search={search}
                  loading={ongoingLoading}
                  handleDeleteEvent={handleDeleteEvent}
                  type={currentTab}
                  showDelete={showDelete}
                  setShowDelete={setShowDelete}
                  deleteItem={deleteItem}
                  setDeleteItem={setDeleteItem}
                />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="expired">
              <div className="row">
                <EventsListCards
                  setSideBar={setSideBar}
                  list={expiredList}
                  search={search}
                  loading={expireLoading}
                  handleDeleteEvent={handleDeleteEvent}
                  type={currentTab}
                  showDelete={showDelete}
                  setShowDelete={setShowDelete}
                  deleteItem={deleteItem}
                  setDeleteItem={setDeleteItem}
                />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </>
  );
};

export default Events;
